export default {
  state: {
    billing: {
      country: '',
      state: ''
    },
    shipping: {
      address_1: '',
      different: false,
      country: '',
      state: ''
    },
    coupon: {
      name: '',
      msg: false,
      coupon_amount: 0,
      discount_type: '',
      disabled: true
    }
  },
  mutations: {
    SET_BILLING (state, data) {
      state.billing = data;
    },
    SET_SHIPPING (state, data) {
      state.shipping = data;
    },
    SET_COUPON (state, coupon) {
      state.coupon = coupon;
    }
  },
  actions: {
    fetchBillingAddress ({
      commit
    }, data) {
      commit('SET_BILLING', data);
    },
    fetchShippingAddress ({
      commit
    }, data) {
      commit('SET_SHIPPING', data);
    },
    fetchCoupon ({ commit }, coupon) {
      commit('SET_COUPON', coupon);
    }
  },
  getters: {

  }
};
